<app-navigation></app-navigation>
<app-bookmarks [favoritesOnly]="true"></app-bookmarks>
<app-last-visit></app-last-visit>

<a class="btn btnLeft" (click)="panelState.toggleState('left')"><i class="fa fa-list-ul"></i></a>


